export function pushToDataLayer(eventName, payload = {}) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    console.log('[Ecommerce]', eventName, payload);
    window.dataLayer.push({
      ecommerce: {
        ...payload,
        currencyCode: 'RUB',
      },
    });
  }
  
  // 1. Просмотр товара
  export function viewProduct(product) {
    pushToDataLayer('productDetail', {
      detail: {
        products: [product],
      },
    });
  }
  
  // 2. Просмотр списка товаров
  export function viewItemList(products, listName = 'Product List') {
    pushToDataLayer('productImpression', {
      impressions: products.map(p => ({
        ...p,
        list: listName,
      })),
    });
  }
  
  // 3. Клик по товару в списке
  export function selectProduct(product, listName = 'Product List') {
    pushToDataLayer('productClick', {
      click: {
        actionField: { list: listName },
        products: [product],
      },
    });
  }
  
  // 4. Добавление в корзину
  export function addToCart(product) {
    pushToDataLayer('addToCart', {
      add: {
        products: [product],
      },
    });
  }
  
  // 5. Удаление из корзины
  export function removeFromCart(product) {
    pushToDataLayer('removeFromCart', {
      remove: {
        products: [product],
      },
    });
  }
  
  // 6. Начало оформления заказа
  export function beginCheckout(products) {
    pushToDataLayer('beginCheckout', {
      checkout: {
        actionField: { step: 1 },
        products,
      },
    });
  }
  
  // 7. Отправка информации о доставке/оплате
  export function setCheckoutOption(step, option) {
    pushToDataLayer('setCheckoutOption', {
      checkout_option: {
        actionField: {
          step,
          option,
        },
      },
    });
  }
  
  // 8. Покупка
  export function purchase(id, products, revenue) {
    pushToDataLayer('purchase', {
      purchase: {
        actionField: {
          id: String(id),
          revenue: revenue,
        },
        products,
      },
    });
  }